// extracted by mini-css-extract-plugin
export default {"frame":"Frame_frame__6AM1N"};